import React from "react"
import { keyframes, useTheme } from "@mui/material"

import { AppDataTable } from "../index"
import { mergeDicts } from "@ui-seeker/utils"
import { grey } from "@mui/material/colors"


export default function AppCrudTable({ data, columns, ...props }) {
	const { palette } = useTheme()

	return <AppDataTable
		data={data}
		columns={columns}
		toolbarProps={{ actions: false }}
		{...props}
		options={{
			search: true,
			exportExcel: true,
			...props?.options,
			enhancedSetRowProps: (rowData, dataIndex, idx) => mergeDicts({
				sx: {
					backgroundColor: idx % 2 === 0 ? "background.grey" : "background.lightGrey",
					borderColor: "colors.grey",
					"&.MuiTableRow-hover:hover": {
						backgroundColor: grey[300]
					},
					"&.mui-row-selected": {
						backgroundColor: palette.primary.light + ' !important'
					},
					"&:has(.is-loading)": {
						animation: `${keyframes({
							"0%": { backgroundColor: palette.primary.light },
							"100%": { backgroundColor: palette.primary.lighter }
						})} 1s linear infinite alternate`
					},
					"&:has(.clicked-details)": {
						backgroundColor: palette.primary.light
					}
				}
			}, props?.options?.enhancedSetRowProps && props?.options?.enhancedSetRowProps())
		}}
	/>
}